import {
  Stepper as BaseStepper,
  styled,
  Grid as GridBase,
  StepLabel as BaseStepLabel,
  Box,
  Table,
  TableRow,
  IconButton,
  Typography,
  TableCell,
  TableHead,
} from "@mui/material";

export const FormContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(4, 0),
}));

export const GridContainer = styled((props) => (
  <GridBase {...props} container />
))`
  &.MuiGrid-container {
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
    /* width: 100%; */
  }
`;

export const PeriodicIsoFormRootArea = styled((props) => (
  <GridContainer {...props} />
))``;

export const GridItem = styled((props) => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${(props) => props.flexDirection || "column"};
    margin: ${(props) => props.margin || "0"};
    padding: ${(props) => props.padding || "0"};
  }
`;

export const Stepper = styled(BaseStepper)(({ theme }) => ({
  backgroundColor: theme.palette.blokko.taglineMist,
  borderRadius: 0,
  marginBottom: 3,
  padding: 2,
}));

export const StepLabel = styled((props) => <BaseStepLabel {...props} />)`
  color: ${(props) => props.color || "text.secondary"};
  font-weight: ${(props) => props.fontWeight || "normal"};
`;

export const FormActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: theme.spacing(3),
}));

export const FileUploadContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
}));

export const OwnersHeaderContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const OwnersActionsContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

// Nuevos componentes para la UI de datos del ISO
export const DataCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(3),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: `1px solid ${theme.palette.divider}`,
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    transform: "translateY(-2px)",
  },
}));

export const DataCardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  borderBottom: `2px solid ${theme.palette.primary.main}`,
}));

export const DataCardTitle = styled(Box)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginLeft: theme.spacing(1),
}));

export const DataCardContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const DataItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(1, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  "&:last-child": {
    borderBottom: "none",
  },
}));

export const DataLabel = styled(Box)(({ theme }) => ({
  fontSize: "0.9rem",
  fontWeight: 500,
  color: theme.palette.text.secondary,
  textTransform: "uppercase",
  letterSpacing: "0.5px",
}));

export const DataValue = styled(Box)(({ theme }) => ({
  fontSize: "1.1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  textAlign: "right",
}));

export const AmountValue = styled(DataValue)(({ theme, positive }) => ({
  color: positive ? theme.palette.success.main : theme.palette.error.main,
  fontWeight: 700,
}));

export const ISOHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(3),
  textAlign: "center",
}));

export const ISOHeaderTitle = styled(Box)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 700,
  marginBottom: theme.spacing(0.5),
}));

export const ISOHeaderSubtitle = styled(Box)(({ theme }) => ({
  fontSize: "1rem",
  opacity: 0.9,
}));

// Componentes para la tabla de holdings
export const HoldingsTableContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(1),
  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
  border: `1px solid ${theme.palette.divider}`,
  overflow: "hidden",
}));

export const HoldingsTable = styled(Table)(({ theme }) => ({
  width: "100%",
  "& .MuiTableCell-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(1.5, 2),
  },
  "& .MuiTableHead-root .MuiTableCell-root": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    padding: theme.spacing(2),
  },
  "& .MuiTableBody-root .MuiTableCell-root": {
    fontSize: "0.875rem",
    padding: theme.spacing(1.5, 2),
  },
}));

export const HoldingsTableRow = styled(TableRow)(({ theme, isOpen }) => ({
  backgroundColor: isOpen
    ? theme.palette.background.paper
    : theme.palette.blokko.tableRowAlt,
  "&:hover": {
    backgroundColor: isOpen
      ? theme.palette.background.paper
      : theme.palette.blokko.tableRowHover,
  },
  "&.MuiTableRow-root": {
    "& > *": {
      borderBottom: "unset",
    },
  },
}));

export const HoldingsExpandButton = styled(IconButton)(({ theme }) => ({
  padding: theme.spacing(0.5),
  "&:hover": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

export const HoldingsCollapseContent = styled(Box)(({ theme }) => ({
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  backgroundColor: theme.palette.blokko.taglineMist,
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.divider}`,
}));

export const HoldingsCollapseTitle = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(1),
}));

export const HoldingsValueCell = styled(TableCell)(({ theme, positive }) => ({
  fontWeight: 600,
  color: positive ? theme.palette.success.main : theme.palette.error.main,
  textAlign: "right",
}));

export const HoldingsAmountCell = styled(TableCell)(({ theme, positive }) => ({
  fontWeight: 600,
  color: positive ? theme.palette.success.main : theme.palette.error.main,
  textAlign: "right",
  "&::before": {
    content: positive ? '"+"' : '"-"',
    marginRight: theme.spacing(0.5),
  },
}));

export const HoldingsTableHeader = styled(TableHead)(({ theme }) => ({
  "& .MuiTableCell-root": {
    position: "sticky",
    top: 0,
    zIndex: 1,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontWeight: 700,
    fontSize: "0.875rem",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
}));
